import { useState } from 'react';
import {
  IlogisticServiceDetails,
  IlogisticServiceTrelloCardData,
  LOGISTIC_SERVICE_STATUS_NAME
} from '../../../../../../../types/services';
import { NudosButton } from '../../../../../../../components/NudosComponents';
import { getLogisticServicesTrelloDataByState } from 'services/services';
import { OffboardingToWarehouseModal } from 'views/services/components/ModalsLogisticsService/OffboardingToWarehouseModal/OffboardingToWarehouseModal';
import GenericLoader from '../../../../../../../components/GenericLoader';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';

import './UpdateToolsTrigger.scss';

interface UpdateToolsTriggerProps {
  logisticServiceData: IlogisticServiceDetails;
  updateDataCallback: () => Promise<void>;
}

const getCurrentStatus = (logisticServiceData: IlogisticServiceDetails) => {
  if (logisticServiceData?.delayed) {
    return LOGISTIC_SERVICE_STATUS_NAME.DELAYED;
  }

  if (logisticServiceData?.statusName) {
    return logisticServiceData?.statusName?.toLowerCase();
  }

  return LOGISTIC_SERVICE_STATUS_NAME.CONFIRMED;
};

export const UpdateToolsTrigger = ({ logisticServiceData, updateDataCallback }: UpdateToolsTriggerProps) => {
  const [showModal, setShowModal] = useState(false);
  const [extraData, setExtraData] = useState<IlogisticServiceTrelloCardData | null>(null);
  const [isLoadingExtraData, setIsLoadingExtraData] = useState(false);
  const { id: logisticServiceId } = logisticServiceData;
  const currentStatus = getCurrentStatus(logisticServiceData);

  const handleOpenModal = async () => {
    if (!logisticServiceId || !currentStatus) return;

    setIsLoadingExtraData(true);
    try {
      const [extraData] = await getLogisticServicesTrelloDataByState([
        `/logistic-service/${currentStatus}?search=${logisticServiceId}`,
        currentStatus
      ]);

      if (!extraData) {
        displayErrorNotification({
          customJSXMessage: <>No se encontraron datos para el servicio logístico</>
        });
        return;
      }

      setExtraData(extraData);
      setShowModal(true);
    } catch {
      displayErrorNotification({
        customJSXMessage: <>Error al cargar datos para el servicio logístico</>
      });
    } finally {
      setIsLoadingExtraData(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    updateDataCallback();
  };

  return (
    <>
      <NudosButton
        buttonText="Actualizar herramientas"
        customWidth="11.25rem"
        customHeight="1.5rem"
        handleClick={handleOpenModal}
      />

      {isLoadingExtraData && (
        <div className="updateToolsTriggerButton">
          <GenericLoader />
        </div>
      )}

      {showModal && extraData && (
        <OffboardingToWarehouseModal
          cardData={extraData}
          serviceDetails={logisticServiceData}
          closeModalCallback={handleCloseModal}
          closeModalAfterSubmitCallback={updateDataCallback}
          isUpdateTools
        />
      )}
    </>
  );
};
